<template>
	<div class="d-flex bd-highlight justify-content-center h-75">
		<div class="box align-self-center">
			<div
				class="p-2 bd-highlight align-self-center welcome-text"
				v-if="mostrarPassword"
			>{{welcome}}</div>
			<div
				class="p-2 bd-highlight align-self-center business-text"
				v-if="mostrarPassword"
			>
				{{business}}
				<span class="ml-2">
					<a @click="cancelarLogin" class="btn-close" v-show="mostrarPassword">
						<i class="fa fa-times-circle"></i>
					</a>
				</span>
			</div>
			<div class="p-2 bd-highlight align-self-center user-text">Usuario</div>
			<div class="p-2 bd-highlight align-self-center">
				<div class="wrapper">
					<!-- <i class="fas fa-spinner fa-spin fa-lg" v-show="loading"></i> -->
					
					<input  @keyup.enter.prevent.stop="accion()"						
							class="form-control inputText"							
							id="txtUsuario"
							ref="txtUsuario"
							type="text"
							name="username"
							v-model="usuario"
							autocomplete="on"
					/>
					<div class="p-2 bd-highlight align-self-center user-text"
							v-if="obteniendoPassword==false"
							>
						Contraseña
					</div>					
					<input  @keyup.enter.prevent.stop="accion()"
							class="form-control inputPassword"
							id="txtPassword"
							ref="txtPassword"
							type="password"
							name="password"
							v-model="password"
							v-if="obteniendoPassword==false"
							autocomplete="on"
					/>					
				</div>
			</div>
			<div class="p-2 bd-highlight align-self-start incorrect-text text-left"
				v-if="!usuarioValido"
			>{{textIncorrect}}</div>
			<div class="p-2 pt-5 bd-highlight align-self-center mx-1 mx-md-5">
				<button v-if="loading == false" id="btnSiguiente"
						@click="accion()"
						class="btn btn-block text-white btn-blue-1"
						type="button"
				>Siguiente</button>
				<button v-else 
						class="btn btn-block text-white btn-blue-1"
						disabled
						type="button"
				>Espere un momento ... <i class="fa fa-spinner fa-spin fa-lg ml-2"></i> </button>

			</div>

			<div
				class="p-2 bd-highlight align-self-center password-question"
			>
				<a @click="olvidePassword" 
					v-if="obteniendoPassword==false"
					class="pointer">
					¿Olvidaste tu contraseña?
				</a>
				<div style="font-size:9px">V.{{versionWeb}}</div>
			</div>
		</div>

		<b-modal hide-footer id="modal-recuperar-password" 
					no-close-on-backdrop
					no-close-on-esc
					hide-header-close
					size="lg">
			<p class="text-center">Se enviara un enlace a su correo para restablecer su contraseña.</p>
			<div class="d-flex justify-content-center">
				<Button
					@click="inicializar()"
					block
					class="m-3 btn btn-secondary"
					style="width:200px;"
				>Cancelar</Button>
				<Button
					@click="enviarCorreo"
					block
					class="m-3 btn btn-primary"
					style="width:200px;"
				>Enviar correo</Button>
			</div>
		</b-modal>

		<!--
		<b-modal id="modal-recuperar-password" size="lg" @ok="enviarCorreo">
			<div>
				Se enviara un enlace a su correo para reestablecer su contraseña.
			</div>
		</b-modal>
		-->
	</div>
</template>

<script>
	import servicio from "@/services/servicio-publica"	
	import Swal from "sweetalert2"
	import {version} from '../../../package'

	export default {
		name: "Login",
		data() {
			return {
				usuario: "",
				password: "",
				title: "Siguiente",
				welcome: "Bienvenido",
				business: "Dilopsan S.A DE C.V.",
				usuarioValido: true,
				textIncorrect: "",
				loading: false,
				obteniendoPassword: false,				
				mostrarPassword : false,
				tokenDifarmer:{
					token:null,
					expiresAt:null,
					refreshToken:null,
					user:null,
					soloConsulta:false
				},
				versionWeb: version,
			}
		},
		mounted() {
			this.inicializar()
		},
		methods: {
			enviarCorreo() {
				servicio.recuperarPasswordCorreo(this.usuario).then(r => {
					if (r.value) {
						Swal.fire({
							text: r.message,
							icon: "success"
						})
						this.$emit("envioCorreo")
					} else {
						Swal.fire({
							text: r.message,
							icon: "warning"
						})
					}
				})
				this.$bvModal.hide("modal-recuperar-password")
			},
			inicializar(){
				this.$refs.txtUsuario.focus()
				this.usuarioValido = true
				this.mostrarPassword = false
				this.loading = false
				this.$bvModal.hide("modal-recuperar-password")
				this.obteniendoPassword = false
				this.usuario=''
				this.password=''
			},
			accion(){
				this.textIncorrect = ""
				if(this.obteniendoPassword){
					this.verificaUsuario()
				}
				else{
					this.iniciarSesion()
				}
			},
			olvidePassword(){
				this.obteniendoPassword=true
				this.$nextTick(() => this.$refs.txtUsuario.focus())
			},
			cancelarLogin() {
				this.mostrarPassword = false
				this.password = ""
				this.title = "Usuario"
				this.$nextTick(() => {
					this.$refs.txtUsuario.focus()
					this.usuario = ""
				})
			},			
			// async iniciarSesion() {
			// 	//let r = window.getIP()
			// 	//console.log("r=>", r)

			// 	if(this.usuario.length == 0){
			// 		this.$nextTick(() => this.$refs.txtUsuario.focus())
			// 	}
			// 	else if(this.password.length == 0){
			// 		this.$nextTick(() => this.$refs.txtPassword.focus())
			// 	}
			// 	else{
			// 		this.loading = true
			// 		servicio.login(this.usuario, this.password).then(r => {
			// 			if (r.value) {
			// 				this.loading = false
			// 				//window.localStorage.token = r.data.accessToken
			// 				//window.localStorage.expiresAt = r.data.expiresAt
			// 				//window.localStorage.refreshToken = r.data.refreshToken
			// 				let tk = r.data.accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")
			// 				//window.localStorage.user =  decodeURIComponent(escape(window.atob(tk)));

			// 				this.tokenDifarmer.token = r.data.accessToken
			// 				this.tokenDifarmer.expiresAt = r.data.expiresAt
			// 				this.tokenDifarmer.refreshToken = r.data.refreshToken
			// 				this.tokenDifarmer.user = decodeURIComponent(escape(window.atob(tk)));

			// 				window.localStorage.tokenDifarmer = JSON.stringify(this.tokenDifarmer)

			// 				// window.localStorage.user=window.atob(
			// 				// 	r.data.accessToken.split(".")[1]
			// 				// )
			// 				// //decodifica los caracteres raros como asentos que bienen de la bd
			// 				// var decode=decodeURIComponent(escape(window.localStorage.user))
			// 				// window.localStorage.user=decode

			// 				localStorage.setItem('mostrarPopUp', 'true');

			// 				this.$router.push({ path: "/clientes/" })								
			// 				//console.log(window.localStorage.user)
			// 				//window.location.href = "http://172.19.4.130/beta/clientes/"


			// 			} else {							
			// 				this.textIncorrect = "* La contraseña es incorrecta."
			// 				this.usuarioValido = false
			// 				this.loading = false
			// 				this.$nextTick(() => this.$refs.txtPassword.focus())
			// 			}
			// 		})
			// 	}
			// },		
			async iniciarSesion(){
				if(this.usuario.length == 0){
					this.$nextTick(() => this.$refs.txtUsuario.focus())
				}
				else if(this.password.length == 0){
					this.$nextTick(() => this.$refs.txtPassword.focus())
				}

				this.loading = true

				const timeoutPromise = new Promise((resolve, reject) => {
					setTimeout(() => reject(new Error("Timeout")), 35000); // Ajusta el tiempo según sea necesario
				});

				try {
					let r = await Promise.race([
						servicio.login(this.usuario, this.password),
						timeoutPromise
					]);

					if (r.value) {
						let tk = r.data.accessToken.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")

						this.tokenDifarmer.token = r.data.accessToken
						this.tokenDifarmer.expiresAt = r.data.expiresAt
						this.tokenDifarmer.refreshToken = r.data.refreshToken
						this.tokenDifarmer.user = decodeURIComponent(escape(window.atob(tk)));
						this.tokenDifarmer.soloConsulta = false

						window.localStorage.tokenDifarmer = JSON.stringify(this.tokenDifarmer)

						localStorage.setItem('mostrarPopUp', 'true');

						const tokenObj = JSON.parse(this.tokenDifarmer.user);
						const forzarPOC = tokenObj.forzarPOC;
						localStorage.setItem('forzarPOC', forzarPOC);

						this.$router.push({ path: "/clientes/" })		

					} else {							
						this.textIncorrect = "* La contraseña es incorrecta."
						this.usuarioValido = false
						this.$nextTick(() => this.$refs.txtPassword.focus())
					}

				} catch (error) {
					console.log(error)
					this.textIncorrect = error.message === "Timeout" ? "* La solicitud ha tardado demasiado tiempo, por favor intente de nuevo." 
																	: "* Error al conectar con el servidor. Por favor Intente de nuevo.";
					this.usuarioValido = false
					this.$nextTick(() => this.$refs.txtPassword.focus())
				} finally {
					this.loading = false
				}
			},
			verificaUsuario() {
				this.loading = true
				servicio.validarNombreUsuario(this.usuario).then(r => {
					if (r.value) {
						this.mostrarPassword = true
						this.business = r.data[0].nombre
						this.usuarioValido = true
						this.$bvModal.show("modal-recuperar-password")
					} else {
						this.textIncorrect = "* El usuario es incorrecto."
						this.usuarioValido = false
						this.$nextTick(() => this.$refs.txtUsuario.focus())
					}
					this.loading = false
					return
				})
				this.loading = false				
			}
		}
	}
</script>

<style scoped>
	.pointer {
		cursor: pointer;
	}
	.wrapper {
		position: relative;
	}
	i.fas {
		position: absolute;
		top: 15px;
		right: 10px;
	}

	.btn-close {
		cursor: pointer;
		transition: all 200ms ease-in;
		margin: auto auto;
	}
	.btn-close:hover {
		font-size: 85%;
	}

	/* sm 576 */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 767px) {
		.box {
			min-width: 338px;
		}

		.fuenteBoton {
			font-family: "Open Sans", sans-serif;
			font-size: 16px !important;
			background-color: var(--color-azul) !important;
		}

		.inputText,
		.inputPassword {
			outline: none !important;
			box-shadow: none !important;
			background-color: transparent !important;
			border: 0 !important;
			border-radius: 0px !important;
			border-bottom: 1px solid white !important;
			font-size: 22px;
			color: white !important;
		}

		.welcome-text {
			font-size: 24px;
		}

		.user-text {
			font-size: 24px;
		}

		.business-text {
			font-size: 14px;
		}

		.password-question {
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			cursor: pointer;
			border: #f04e0e;
		}

		.incorrect-text {
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			color: #f04e0e;
		}
	}
	/* md 768 */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.box {
			min-width: 470px;
		}

		.fuenteBoton {
			font-family: "Open Sans", sans-serif;
			font-size: 16px !important;
			background-color: var(--color-azul) !important;
		}

		.inputText,
		.inputPassword {
			outline: none !important;
			box-shadow: none !important;
			background-color: transparent !important;
			border: 0 !important;
			border-radius: 0px !important;
			border-bottom: 1px solid white !important;
			font-size: 22px;
			color: white !important;
		}

		.welcome-text {
			font-size: 18px;
		}

		.user-text {
			font-size: 24px;
		}

		.business-text {
			font-size: 14px;
		}

		.password-question {
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
		}

		.incorrect-text {
			font-size: 14px;
			font-family: "Open Sans", sans-serif;
			color: #f04e0e;
		}
	}
	/* lg 992 */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.box {
			min-width: 545px;
		}

		.fuenteBoton {
			font-family: "Open Sans", sans-serif;
			font-size: 16px !important;
			background-color: var(--color-azul) !important;
		}

		.inputText,
		.inputPassword {
			outline: none !important;
			box-shadow: none !important;
			background-color: transparent !important;
			border: 0 !important;
			border-radius: 0px !important;
			border-bottom: 1px solid white !important;
			font-size: 22px;
			color: white !important;
		}

		.welcome-text {
			font-size: 28px;
		}

		.user-text {
			font-size: 28px;
		}

		.business-text {
			font-size: 18px;
		}

		.password-question {
			font-size: 16px;
			font-family: "Open Sans", sans-serif;
		}

		.incorrect-text {
			font-size: 16px;
			font-family: "Open Sans", sans-serif;
			color: #f04e0e;
		}
	}
	/* xl 1200 */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 1200px) and (max-width: 1919px) {
		.box {
			min-width: 545px;
		}

		.fuenteBoton {
			font-family: "Open Sans", sans-serif;
			font-size: 16px !important;
			background-color: var(--color-azul) !important;
		}

		.inputText,
		.inputPassword {
			outline: none !important;
			box-shadow: none !important;
			background-color: transparent !important;
			border: 0 !important;
			border-radius: 0px !important;
			border-bottom: 1px solid white !important;
			font-size: 22px;
			color: white !important;
		}

		.welcome-text {
			font-size: 32px;
		}

		.user-text {
			font-size: 32px;
		}

		.business-text {
			font-size: 24px;
		}

		.password-question {
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
		}

		.incorrect-text {
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			color: #f04e0e;
		}
	}
	/* > xl 1920 */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1920px) {
		.box {
			min-width: 545px;
		}

		.fuenteBoton {
			font-family: "Open Sans", sans-serif;
			font-size: 16px !important;
			background-color: var(--color-azul) !important;
		}

		.inputText,
		.inputPassword {
			outline: none !important;
			box-shadow: none !important;
			background-color: transparent !important;
			border: 0 !important;
			border-radius: 0px !important;
			border-bottom: 1px solid white !important;
			font-size: 22px;
			color: white !important;
		}

		.welcome-text {
			font-size: 32px;
		}

		.user-text {
			font-size: 32px;
		}

		.business-text {
			font-size: 24px;
		}

		.password-question {
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
		}

		.incorrect-text {
			font-size: 18px;
			font-family: "Open Sans", sans-serif;
			color: #f04e0e;
		}
	}
</style>